import { Component } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';

@Component({
  selector: 'app-subscription-seller-plan',
  templateUrl: './subscription-seller-plan.component.html',
  styleUrls: ['./subscription-seller-plan.component.css']
})
export class SubscriptionSellerPlanComponent {
  propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;

  constructor(public shared: SharedService, public apiService: ApiServiceService) {
    this.shared.isWhiteMenu = true;
  }

  async onSubmit(type: any) {
    let amount: any;
    if (type == 1) {
      amount = 175
    } else {
      amount = 350
    }
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.ADD_SUBSCRIPTION_PLAN, {
      subscription_type: 4,
      subscription_sub_type: type,
      subscription_date: new Date(),
      subscription_amount: amount
    })
    if (res && !res.error) {
      window.location.href = '/';
    }
  }
}
